@let texts = resourcesService.languageFile.value();
<div id="start-container">
  <div id="inner-start-container">
    <p-button (onClick)="showInfo()" [text]="true" class="info-button round-button">
      <img src="assets/icons/info.png" alt="{{texts.gameInstructionsTitle}}">
    </p-button>

    <h1 class="header">{{ texts.gameName }}</h1>

    <div class="intro-text">{{ texts.startText }}</div>

    @for(theme of resourcesService.themes(); track theme.id) {
      <gis-theme-card [theme]="theme"/>
    }

    <gm-modal #gmModal
              [title]="texts.gameInstructionsTitle"
              content="{{texts.gameInstructions.join('<br><br>')}}"
              notificationState="{{'information'}}"
              (hide)="hideInfo()"
    ></gm-modal>
  </div>
</div>
